export default __webpack_public_path__ + "static/media/View3.5fe4c74b.svg";